import {Component, Input, OnInit, Renderer2} from '@angular/core';
import {DeviceDetectorService} from 'ngx-device-detector';
import {Router} from '@angular/router';
import * as $ from 'jquery';

@Component({
  selector: 'app-product-card',
  templateUrl: './product-card.component.html',
  styleUrls: ['./product-card.component.css']
})
export class ProductCardComponent implements OnInit {

  public products;

  // device identification
  public deviceInfo;
  public isMobile;
  public isDesktopDevice;


  constructor(
    private deviceService: DeviceDetectorService,
    private renderer: Renderer2,
    private router: Router
  ) {
    this.deviceInfo = this.deviceService.getDeviceInfo();
    this.isMobile = this.deviceService.isMobile();
    this.isDesktopDevice = this.deviceService.isDesktop();
  }

  @Input()
  get data(): string {
    return this.products;
  }

  set data(data: any) {
    this.products = data;
  }

  ngOnInit(): void {
  }

  public onVideoIntersection({target, visible}: { target: any; visible: boolean }): void {

    if (!this.isMobile) {
      return;
    }

    this.renderer.addClass(target, visible ? 'active' : 'inactive');
    this.renderer.removeClass(target, visible ? 'inactive' : 'active');

    // this.renderer.setProperty(target, 'play', true);
    // target.nativeElement.play();
    if (visible) {
      target.play();
    } else {
      target.pause();
    }
  }

  onScroll(): void {
    // emit the scroll event
  }

  playVideo(e): void {
    e.play();
  }

  pauseVideo(e): void {
    e.pause();
  }

  videoVolumeControl(e): void {
    const x = $(e).attr('src');
    (x == 'assets/images/icons/sound.png') ? $(e).attr('src', 'assets/images/icons/mute.png') : $(e).attr('src', 'assets/images/icons/sound.png');
    (x == 'assets/images/icons/sound.png') ? $(e).parents('.image').find('video').prop('muted', true) : $(e).parents('.image').find('video').prop('muted', false);
  }

  showProductDetail(product): void {
    this.router.navigate(['c/' + product.details.city.toLowerCase().toString() + '/' + product.details.slug], {state: product});
  }


}
